import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useMatch } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import PostShiftPage from './pages/PostShiftPage';
import PostAvailabilityPage from './pages/PostAvailabilityPage';
import AccountPage from './pages/AccountPage';
import AdminPage from './pages/AdminPage';
import MedallionsPage from './pages/MedallionsPage';
import PostMedallionPage from './pages/PostMedallionPage';
import ContactWidget from './components/ContactWidget';
import { useAuth } from './context/AuthContext';
import { AirportTicker } from './components/dashboard';
import './App.css';
import './components/ErrorBoundary.css';

function HomeRedirect() {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  if (loading) return null;
  if (isAuthenticated) {
    return <Navigate to={isAdmin ? '/admin' : '/dashboard'} replace />;
  }
  return <LandingPage />;
}

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <div className="page-transition" key={location.pathname}>
      <Routes location={location}>
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/car-listing"
          element={
            <ProtectedRoute>
              <PostShiftPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/driver-listing"
          element={
            <ProtectedRoute>
              <PostAvailabilityPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/medallions"
          element={
            <ProtectedRoute>
              <MedallionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/medallion-listing"
          element={
            <ProtectedRoute>
              <PostMedallionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <AccountPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

function DashboardTicker() {
  const isDashboard = useMatch('/dashboard');
  const isMedallions = useMatch('/medallions');
  if (!isDashboard && !isMedallions) return null;
  return <AirportTicker />;
}

function AuthenticatedContactWidget() {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return null;
  return <ContactWidget />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="app">
            <Navbar />
            <DashboardTicker />
            <main className="main-content">
              <ErrorBoundary>
                <AnimatedRoutes />
              </ErrorBoundary>
            </main>
            <AuthenticatedContactWidget />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
